import React from "react";
import "./GameCard.css";

const GameCard = ({ card, handleChoice, flipped, disabled }) => {
  const handleClick = () => {
    if (!disabled) {
      handleChoice(card);
    }
  };

  return (
    <div className="card">
      <div className={`card-inner ${flipped ? "flipped" : ""}`} onClick={handleClick}>
        <div className="card-front">
          <img src={card.src} alt="card" />
        </div>
        <div className="card-back"></div>
      </div>
    </div>
  );
};

export default GameCard;
